import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { map } from 'rxjs/operators';
import {
	DispatchTypes,
	CondoCorporationModalComponent,
} from '../../../property/condo-corp/condo-corporation-modal/condo-corporation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MatterDispatch } from '@state/matter';
import { CondoCorporation } from '@models/matter';
import {
	DeleteConfirmationModalComponent,
	DeleteModalTypes,
} from '../../../property/condo-corp/delete-confirmation-modal/delete-confirmation-modal.component';
import { addressString } from '@core/util/address';
import { FirmCardType } from 'src/app/shared/atomic/organisms/firm-card/firm-card.component';
import { AI_GENERATED_ICON } from '@core/util/icon';

@Component({
	selector: 'app-sale-condo-corp-search-card',
	templateUrl: './condo-corp-search-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CondoCorpSearchCardComponent {
	private condoCorpData$ = inject(Store).select(
		SelectedMatter.condoCorporation,
	);
	public AI_GENERATED_ICON = AI_GENERATED_ICON;

	public condoCorp$ = this.condoCorpData$.pipe(
		map((corporationObject) => corporationObject?.condoCorp),
	);

	public firmCardType$ = this.condoCorpData$.pipe(
		map((condoCorp) =>
			condoCorp?.management ? FirmCardType.MINIMIZED : FirmCardType.FULL,
		),
	);

	public condoCorpAddressString$ = this.condoCorp$.pipe(
		map((condoCorp) => addressString(condoCorp?.address)),
	);

	public showAiIcon$ = inject(Store)
		.select(SelectedMatter.getFieldMappings)
		.pipe(map((fieldMappings) => !!fieldMappings?.condoCorporation?.condoCorp));

	public label = 'Condo Corporation';

	private matDialog = inject(MatDialog);
	private matterDispatch = inject(MatterDispatch);

	onCreateCondoCorporation(name: string) {
		this.matDialog.open(CondoCorporationModalComponent, {
			data: {
				name,
				dispatchType: DispatchTypes.CONDO_CORP,
			},
		});
	}

	onSelectCondoCorporation(selectedCondoCorp: CondoCorporation) {
		this.matterDispatch.SetCondoCorporationCompany(selectedCondoCorp.id);
	}

	condoCorpDropdownEvent(event, condoCorp: CondoCorporation) {
		switch (event.result.name) {
			case 'Edit':
				this.matDialog.open(CondoCorporationModalComponent, {
					data: {
						dispatchType: DispatchTypes.CONDO_CORP,
						company: condoCorp,
					},
				});
				break;
			case 'Remove':
				this.matDialog.open(DeleteConfirmationModalComponent, {
					data: {
						deleteModalType: DeleteModalTypes.CONDO_CORPORATION,
					},
				});
				break;
		}
	}
}
